import React, { ComponentType, PropsWithChildren } from 'react'
import { MantineProvider, MantineThemeOverride } from '@mantine/core'
import useThemeListener from './hooks/useThemeListener'
import { mantineDefaultProps } from './providerProps'

export const MantineWrappedProvider = ({
    children,
    ...props
}: PropsWithChildren<MantineThemeOverride>): JSX.Element => {
    const { theme } = useThemeListener()

    return (
        <MantineProvider theme={{ colorScheme: theme, ...props, ...mantineDefaultProps }} withNormalizeCSS>
            {children}
        </MantineProvider>
    )
}

export function withMantineProviderWrapper<P>(
    Component: ComponentType<P>,
    externalProps: MantineThemeOverride = {}
): ComponentType<P> {
    const Wrapped: React.FC<P> = props => {
        return (
            <MantineWrappedProvider {...externalProps}>
                <Component {...props} />
            </MantineWrappedProvider>
        )
    }

    return Wrapped
}
